import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["upgradeKey", "children"];
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { useUpgradePoint } from 'ui-addon-upgrades/ums/useUpgradePoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UpgradePointButton = _ref => {
  let {
      upgradeKey,
      children
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    openUpgradePage
  } = useUpgradePoint(upgradeKey);
  return /*#__PURE__*/_jsx(Button, Object.assign({
    onClick: openUpgradePage
  }, buttonProps, {
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      flex: 1,
      children: [children, /*#__PURE__*/_jsx(LockBadge, {
        alignWithText: true
      })]
    })
  }));
};
export default UpgradePointButton;